<div [innerHTML]="displayTextWithCursor()" class="typewriter--output"></div>
@if (tableHtml) {
  <div [innerHTML]="tableHtml"></div>
}
